import { App } from 'vue'

import AuthLayout from './AuthLayout.vue';
import DefaultLayout from './DefaultLayout.vue';

export default {
    bind(app: App<Element>) {
        app.component('default-layout', DefaultLayout)
        app.component('auth-layout', AuthLayout)
    }
}
